export default __webpack_public_path__ + "static/product-eng-859f9e1404a2096859739a70ec8b62f6.svg";